import { render, staticRenderFns } from "./crmBranchsCreate.vue?vue&type=template&id=8d7db302&scoped=true"
import script from "./crmBranchsCreate.vue?vue&type=script&lang=js"
export * from "./crmBranchsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7db302",
  null
  
)

export default component.exports